var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckValidIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 7,
  fill: "var(--color-success-bg, rgba(52, 211, 153, 0.15))",
  stroke: "var(--color-success-border, rgba(52, 211, 153, 0.6))"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "var(--color-success, #34d399)",
  d: "m5 8 2 2 4-4"
})));
export default SvgCheckValidIcon;